{"version":"0.13.1","api":{"authHost":"https://physicians.kinexmedical.com:4000","dataHost":"https://physicians.kinexmedical.com:5000"}}